import type { ComponentType } from 'react';
import { CRYPTO_PROVIDER, type CryptoProvider } from '../../../types/enums';
import CryptoDepositForm from './CryptoDepositForm';
import CryptoWithdrawForm from './CryptoWithdrawForm';
import ZeroXDepositForm from '../zero-x/ZeroXDepositForm';
import ZeroXWithdrawForm from '../zero-x/ZeroXWithdrawForm';

type CryptoProviderFormProps = { paymentProvider: string | null };

/** The single place that maps the marketplace's crypto provider to its cashier forms. */
export const CRYPTO_PROVIDER_FORMS: Record<
  CryptoProvider,
  { Deposit: ComponentType<CryptoProviderFormProps>; Withdraw: ComponentType<CryptoProviderFormProps> }
> = {
  [CRYPTO_PROVIDER.MORALIS]: { Deposit: CryptoDepositForm, Withdraw: CryptoWithdrawForm },
  [CRYPTO_PROVIDER.ZERO_X_PROCESSING]: { Deposit: ZeroXDepositForm, Withdraw: ZeroXWithdrawForm },
};
